import { PublisherAffiliateTags } from './publisher-affiliate-tags';

export { PublisherAffiliateTags };
